/**
 * Link styling for sanitized CMS markup inside RichText. `prose-links`
 * underlines in-content anchors; the brand link color is applied here so a
 * CMS `<a>` matches the hen-ui `Link` / `Text color="primary"` token
 * (`text-primary-700`) instead of inheriting the surrounding body color.
 */
export const richTextContentClassName = 'prose-links [&_a]:text-primary-700';

/**
 * Block/list/heading styling for Offerings and Organization Marketing HTML.
 *
 * Headings and emphasis map each CMS tag to its canonical hen-ui typography
 * token — `<h4>` → `text-h4`, `<strong>` → bold — using the SAME
 * `font-heading font-bold text-hN` scale as the `Heading` atomic
 * (`heading.variants.ts`). The `text-hN` tokens are `[fontSize, lineHeight]`
 * tuples in `tailwind.config.ts`, so `text-h4` already emits the correct
 * line-height — no `leading-hN` needed (there is no `theme.lineHeight.hN`).
 * This keeps rich CMS markup on the design system everywhere RichText renders
 * (rankings blurb, offering snippets, TCPA copy) rather than flattening every
 * element to the container's body variant. The container's `variant` still
 * governs the base body size for `<p>`/`<li>`; headings render at their
 * absolute DS size regardless of that base.
 */
export const richTextMarkupClassName = [
  '[&_p]:mb-sm [&_p:last-child]:mb-0',
  '[&_h1]:font-heading [&_h1]:font-bold [&_h1]:text-h1 [&_h1]:mb-xs',
  '[&_h2]:font-heading [&_h2]:font-bold [&_h2]:text-h2 [&_h2]:mb-xs',
  '[&_h3]:font-heading [&_h3]:font-bold [&_h3]:text-h3 [&_h3]:mb-xxs',
  '[&_h4]:font-heading [&_h4]:font-bold [&_h4]:text-h4 [&_h4]:mb-xxs',
  '[&_h5]:font-heading [&_h5]:font-bold [&_h5]:text-h5 [&_h5]:mb-xxs',
  '[&_h6]:font-heading [&_h6]:font-bold [&_h6]:text-h6 [&_h6]:mb-xxs',
  '[&_h2:not(:first-child)]:mt-sm [&_h3:not(:first-child)]:mt-sm [&_h4:not(:first-child)]:mt-sm',
  '[&_strong]:font-bold [&_b]:font-bold [&_em]:italic',
  '[&_ul]:mb-sm [&_ul]:flex [&_ul]:list-disc [&_ul]:flex-col [&_ul]:gap-xs [&_ul]:pl-6',
  '[&_ol]:mb-sm [&_ol]:flex [&_ol]:list-decimal [&_ol]:flex-col [&_ol]:gap-xs [&_ol]:pl-6',
  '[&_li]:text-inherit',
  '[&_blockquote]:border-l-2 [&_blockquote]:border-neutral-200 [&_blockquote]:pl-md',
].join(' ');
